module.exports = __webpack_public_path__ + "img/shape-top.4e2307a6.svg";